// The outbound half of the native-app bridge: everything the web view tells the
// iOS/Android shell goes through `StudyflixApp.postMessage`.

/** The shells inject `window.StudyflixApp`. In a plain browser — and in system specs */
export function installStudyflixApp(): void {
  if (!window.StudyflixApp) {
    window.StudyflixApp = { postMessage() {} }
  }
}

/** `window.StudyflixWeb`, the object the shells call *into*. Created on first use. */
export function studyflixWeb(): NonNullable<Window['StudyflixWeb']> {
  return (window.StudyflixWeb ??= {})
}

/**
 * Send a command to the shell. An object is serialized; a bare string is a command
 * that takes no arguments (e.g. `resetNavigationBar`). See
 * app/vite/test_helpers/javascripts/native_app_mock.ts for the accepted vocabulary.
 */
export function postNativeMessage(message: string | Record<string, unknown>): void {
  window.StudyflixApp?.postMessage(typeof message === 'string' ? message : JSON.stringify(message))
}
